import React from 'react';
import { TooltipDesktop } from '@cian/ui-kit';
import { Label } from '../Label';
import { useOfferContext } from '../../context';
import { BankLabelPopup } from './BankLabelPopup';

export function AgentBankLabel() {
  const { agentBuildersLabel } = useOfferContext();

  return (
    <TooltipDesktop title={<BankLabelPopup />} placement={'bottom'} theme={'white'}>
      <div>
        <Label text={agentBuildersLabel || ''} theme="success" />
      </div>
    </TooltipDesktop>
  );
}
